import axios from "axios";
import { ToastChakra } from "../helpers/toast";
import api from "../helpers/api";

const baseURL = process.env.REACT_APP_API_URL;
const getAllPaises = async (data) => {
    const {page, perPage} = data;
    const response = await api.get(`${baseURL}/pais/list?pagina=${page}&cantidadPagina=${perPage}`);
    console.log('esto traigo en servicio paises:', response.data);
    return response.data;  // Aquí obtienes el objeto con `data` y `pagination`
}

const getListSelectPais = async () => {
    const response = await api.get(`${baseURL}/pais/list/select`);
    if (response.status === 200 || response.status === 201) {
        return response.data;
    }
}


const getPais = async (id, token) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'x-token': token
        },
    }
    const response = await axios.get(`${baseURL}/pais/${id}`, config);
    return response.data.pais;
}

const createPais = async (data) => {
    const response = await api.post(`${baseURL}/pais/crear`, data);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('PAIS CREADO', 'El pais se ha creado correctamente', 'success', 3000, 'bottom-right');
        return response.data;
    }
}

// Update
const updatePais = async (data) => {
    const response = await api.put(`${baseURL}/pais/actualizar/${data.id}`, data);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('PAIS MODIFICADO', 'El pais se ha modificado correctamente', 'success', 3000, 'bottom-right');
        return response.data
    }
}

// Delete a user

const deletePais = async (id) => {

    const response = await api.delete(`${baseURL}/pais/borrar/${id}`);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('PAIS ELIMINADO', 'El pais se ha eliminado correctamente', 'success', 3000, 'bottom-right');
        return response.data;
    }
}

const paisService = {
    getAllPaises,
    getPais,
    createPais,
    updatePais,
    deletePais,
    getListSelectPais
}

export default paisService;